import { Flex, Form, FormInstance, Input } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { BaseButton } from 'components/button/button-base';
import { SelectWithOther } from 'components/form/SelectWithOther';
import { Text, Title } from 'components/mvp-typography';
import { ComponentType, useEffect } from 'react';
import { useImpactPilotMutations } from '../_utils/use-impact-pilot-mutations';
interface FormType {
  passportId: string;
  locationCode: string;
}
interface FormPatientAddProps {
  passportId: string | undefined;
  locationCode?: string;

  onSuccess?: (
    result: { data: { patientId: string } },
    formInstance: FormInstance<FormType>
  ) => void;

  /**
   * Title of the form
   */
  title: { content: string; level?: TitleProps['level'] };
  instructionText: { content: string };
  formInputs?: {
    passportId?: { disabled: boolean };
    locationCode?: { disabled: boolean };
  };
  renderCancel: ComponentType;
  renderFooter: ComponentType<{ isPending: boolean; isSuccess: boolean }>;
}

export function FormPatientAdd(props: FormPatientAddProps) {
  const pilotMutations = useImpactPilotMutations();
  const [form] = Form.useForm<FormType>();

  useEffect(() => {
    form.setFieldValue('passportId', props.passportId);
  }, [props.passportId, form]);

  useEffect(() => {
    form.setFieldValue('locationCode', props.locationCode);
  }, [props.locationCode, form]);

  async function onFinished(values: FormType) {
    pilotMutations.addPatient.mutate(
      {
        passportId: values.passportId,
        locationCode: values.locationCode as any
      },
      {
        onSuccess(result) {
          form.resetFields();
          props.onSuccess?.(result, form);
        }
      }
    );
  }

  return (
    <Form form={form} onFinish={onFinished} labelCol={{ span: 8 }}>
      <Title level={props.title.level}>{props.title.content}</Title>
      <Flex vertical gap={16}>
        <Text>{props.instructionText.content}</Text>
        <Form.Item
          name="locationCode"
          label="Location"
          rules={[
            {
              required: true,
              message: 'A location is required'
            }
          ]}
        >
          <SelectWithOther
            options={[
              {
                value: 'US'
              },
              {
                value: 'CA'
              },
              {
                value: 'EU'
              },
              {
                value: 'INTL'
              },
              {
                value: 'other',
                label: 'Other'
              }
            ]}
            // readOnly={props.formInputs?.locationCode?.disabled}
            disabled={props.formInputs?.locationCode?.disabled}
          ></SelectWithOther>
        </Form.Item>
        <Form.Item
          label="Passport ID"
          name="passportId"
          style={{
            marginBottom: 0
          }}
          rules={[
            {
              required: true,
              message: 'Please enter a Passport ID'
            }
          ]}
        >
          <Input
            data-private="lipsum"
            readOnly={props.formInputs?.passportId?.disabled}
            disabled={props.formInputs?.passportId?.disabled}
          />
        </Form.Item>

        <Text>
          <small style={{ fontStyle: 'italic' }}>
            No other personal information of the test-taker will be shared with
            ConcussionRx at this stage. <br />
          </small>
        </Text>
        <Flex gap={16}>
          <BaseButton
            loading={pilotMutations.addPatient.isPending}
            disabled={
              pilotMutations.addPatient.isPending ||
              pilotMutations.addPatient.isSuccess
            }
            htmlType="submit"
          >
            Add test-taker
          </BaseButton>
          {<props.renderCancel />}
        </Flex>

        {pilotMutations.addPatient.isError && (
          <ErrorDisplay error={pilotMutations.addPatient.error} />
        )}

        {
          <props.renderFooter
            isSuccess={pilotMutations.addPatient.isSuccess}
            isPending={pilotMutations.addPatient.isPending}
          />
        }
      </Flex>
    </Form>
  );
}
